import { useQueryClient } from "@tanstack/react-query";
import { eventTypesForArea } from "../../../app/query/useRealtimeQueryBridge";
import { useRealtimeListRefresh } from "../../../app/realtime/RealtimeContext";
import { RealtimeEventTypes } from "../../../app/realtime/realtimeEventTypes";
import { invalidatePersonDetail } from "./personDetailQueryKeys";

const PERSON_DETAIL_EVENTS = [...new Set([
  ...eventTypesForArea("persons"),
  RealtimeEventTypes.InboxChanged,
  RealtimeEventTypes.OutboundMessagesChanged,
  RealtimeEventTypes.EmailQueueChanged,
  RealtimeEventTypes.SmsQueueChanged,
  RealtimeEventTypes.WhatsAppQueueChanged,
])];

/** Übersicht, Reiterlisten und imperative Teilansichten gemeinsam abgleichen. */
export function usePersonDetailRealtime(personId: string, refreshAccessMedia: () => void) {
  const queryClient = useQueryClient();
  useRealtimeListRefresh({
    eventTypes: PERSON_DETAIL_EVENTS,
    enabled: !!personId,
    reload: () => {
      void invalidatePersonDetail(queryClient, personId);
      refreshAccessMedia();
    },
  });
}
